.wizardBody {
  padding: 40px;
}

.wizardNavButton {
  min-width: 130px;
}

.mobileDivider {
  display: none;
}

@media (--reefer-media-tablet-max) {
  .wizardBody {
    padding: 24px;
  }

  .mobileDivider {
    width: 156px;
    height: 1px;
    background: var(--colors-grays-light);
    border-radius: 24px;
    align-self: center;
    display: block;
  }

  .wizardNavButtons {
    width: 100%;
  }

  .wizardNavButton {
    flex: 1;
  }
}
